export default {
	methods: {
		forwardProcessImgEvent(user, file, callback) {
			this.$emit('process-img', user, file, callback)
		},
		forwardZoomEvent(img) {
			this.$emit('start-zooming', img)
		},
		forwardVisibilityChangesEvent(visibility) {
			this.$emit('visibility-changes', visibility)
		}
	}
}
